export const isoLOB = [
  {
    text: "Workers' Compensation",
    appetiteCode: "wctaldappetiteCd",
    hazardCd: "wchazardCd",
    uWIndexCd: "",
    shortCode: "WC",
  },
  {
    text: "Commercial Auto",
    appetiteCode: "cataldappetiteCd",
    uWIndexCd: "",
    hazardCd: "cahazardCd",
    shortCode: "CA",
  },
  {
    text: "General Liability",
    appetiteCode: "gltaldaappetiteCode",
    uWIndexCd: "",
    hazardCd: "glhazardCd",
    shortCode: "GL",
  },
  {
    text: "Commercial Property",
    appetiteCode: "propertyTALDAppetiteCode",
    uWIndexCd: "",
    hazardCd: "propHazardCd",
    shortCode: "PROP",
  },
  {
    text: (
      <>
        Excess and Surplus
        <div className="fw-normal">Property</div>
      </>
    ),
    appetiteCode: "esptaldAppttCode",
    hazardCd: "esphzrdCode",
    uWIndexCd: "espundrwrtngIntnstyCode",
    shortCode: "ES_P",
  },
  {
    text: (
      <>
        Excess and Surplus
        <div className="fw-normal">General Liability</div>
      </>
    ),
    appetiteCode: "esltaldAppttCode",
    hazardCd: "eslhzrdCode",
    uWIndexCd: "eslundrwrtngIntnstyCode",
    shortCode: "ES_L",
  },
];

export const spectrumLOB = [
  {
    text: "Spectrum (BOP)",
    appetiteCode: "specTALDAppetiteCd",
    hazardCd: "specHazardCd",
    uWIndexCd: "specUNDRWritingIndexCd",
    shortCode: "SPEC",
  },
  {
    text: "Spectrum Umbrella",
    appetiteCode: "specTALDAppetiteCd",
    hazardCd: "N/A - UMB",
    shortCode: "UMB",
    uWIndexCd: "umbundrwritingIndexCd",
  },
  {
    text: "Workers' Compensation",
    appetiteCode: "wctaldappetiteCd",
    hazardCd: "wchazardCd",
    uWIndexCd: "wcundrwritingIndexCd",
    shortCode: "WC",
  },
  {
    text: "Commercial Auto",
    appetiteCode: "cataldappetiteCd",
    hazardCd: "cahazardCd",
    uWIndexCd: "caundrwritingIndexCd",
    shortCode: "CA",
  },
  {
    text: (
      <>
        Management Liability
        {/* wbr tag used to break after FID on tablet sized screens */}
        <div className="fw-normal">
          D&O/EPL/FID
          <wbr />
          /Crime
        </div>
      </>
    ),
    appetiteCode: "mltaldappetiteCode",
    hazardCd: "mlhazardCode",
    uWIndexCd: "",
    shortCode: "ML",
  },
  {
    text: "Cyber",
    appetiteCode: "cyberTalnCd",
    hazardCd: "cyberHazardCd",
    uWIndexCd: "cyberUnderwritingIndexCd",
    shortCode: "CYBER",
  },
  {
    text: (
      <>
        Professional Liability
        <div className="fw-normal">E&O Standalone</div>
      </>
    ),
    appetiteCode: "scpltaldaappetiteCode",
    hazardCd: "scplhazardCode",
    uWIndexCd: "",
    shortCode: "SC_PL",
  },
  {
    text: (
      <>
        Excess and Surplus
        <div className="fw-normal">Property</div>
      </>
    ),
    appetiteCode: "esptaldAppttCode",
    hazardCd: "esphzrdCode",
    uWIndexCd: "espundrwrtngIntnstyCode",
    shortCode: "ES_P",
  },
  {
    text: (
      <>
        Excess and Surplus
        <div className="fw-normal">General Liability</div>
      </>
    ),
    appetiteCode: "esltaldAppttCode",
    hazardCd: "eslhzrdCode",
    uWIndexCd: "eslundrwrtngIntnstyCode",
    shortCode: "ES_L",
  },
];
